import { useTheme } from 'theme/ThemeContext';
import { THEME_NO_SITE } from 'libs/constants';

const useWebsiteMenu = (): { isVisible: boolean } => {
  const { name } = useTheme();

  return {
    isVisible: name !== THEME_NO_SITE,
  };
};

export default useWebsiteMenu;
